var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"createEXCMTaskModal","size":"xl","hide-footer":""},on:{"hidden":_vm.resetData}},[_c('b-row',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('b-col',[_c('h6',[_vm._v(_vm._s(_vm.$t('buttons.finishLastTaskAndClose')))])])],1),_c('b-row',[_c('b-col',[_c('EXCMTaskCreate',{attrs:{"caseIri":_vm.caseIri}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }